import React from "react";
import SelectPartial from "../selectPartial/SelectPartial";

const GetNewInvoiceOptions = ({
  onChangePartialHandler,
  chosenPartial,
}) => {
  return (
    <div className="d-flex align-items-start">
      <SelectPartial
        onChoosePartialHandler={onChangePartialHandler}
        value={chosenPartial}
      />
    </div>
  );
};

export default GetNewInvoiceOptions;
